// Path: ./src/app/components/ImagePreviewModal/styled.ts
import styled from "styled-components";

export const ImageModalWrapper = styled.div`
  position: relative;
`;
